<template>
  <div class="wrapper-sidebar--contact-us">
    <h2>{{ $t(`${base}.title`) }}</h2>
    <p>{{ $t(`${base}.description`) }}</p>
  </div>
</template>

<script>
export default {
  name: 'LadSidebarContactUs',
  data() {
    return {
      base: 'experience.sidebars.contact_us',
    }
  },
}
</script>

<style lang="scss">
.wrapper-sidebar--contact-us {
  padding-right: 15px;
}
</style>
